import React from 'react';
import { Table } from 'reactstrap'; // Assuming reactstrap is used based on UsersPage
import { SignUpReportRowDto } from '@repo/common-types';

interface SignUpReportTableProps {
  data: SignUpReportRowDto[];
  loading: boolean;
  error: string | null;
}

const SignUpReportTable: React.FC<SignUpReportTableProps> = ({ data, loading, error }) => {
  if (loading) {
    return <p>Loading report...</p>;
  }

  if (error) {
    return <p className="text-danger">Error: {error}</p>; // Use Bootstrap class for error text
  }

  return (
    <Table responsive hover className="mb-0">
      <thead>
        <tr>
          <th>Username</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Sign Up Date</th>
          <th>Deposit Total</th>
          <th>Rake Generated</th>
          <th>Last Login</th>
          <th>Referral Code</th>
          {/* <th>Inbound Source</th> */}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td colSpan={8} className="text-center">
              {' '}
              {/* Use Bootstrap class for centering */}
              No data found for the selected period.
            </td>
          </tr>
        ) : (
          data.map((row) => (
            <tr key={row.userId}>
              <td>{row.username}</td>
              <td>{row.firstName}</td>
              <td>{row.lastName}</td>
              <td>{new Date(row.signUpDate).toLocaleDateString()}</td>
              <td>{row.depositTotal.toFixed(2)}</td>
              <td>{row.rakeGenerated.toFixed(2)}</td>
              <td>{row.lastLoginDate ? new Date(row.lastLoginDate).toLocaleString() : ''}</td>
              <td>{row.referralCode || ''}</td>
              {/* <td>{row.inboundSource || 'N/A'}</td> */}
            </tr>
          ))
        )}
      </tbody>
    </Table>
  );
};

export default SignUpReportTable;
